import EditorOverlayStateEnum from 'EditorOverlay/EditorOverlayConstants';
import isFilledPopup from './isFilledPopup';
import isPopupAssignedToCurrentSigner from './isPopupAssignedToCurrentSigner';
import isRequestSignaturePopup from './isRequestSignaturePopup';

const EDIT_SHARE_MODES = [
  EditorOverlayStateEnum.REQUEST_SIGNATURE, // Editing popups.
  EditorOverlayStateEnum.REQUEST_SIGNATURE_WAIT, // Editing non-popup share data.
  EditorOverlayStateEnum.COMPOSE_REQUEST_SIGNERS,
  EditorOverlayStateEnum.COMPOSE_REQUEST_FIELDS,
  EditorOverlayStateEnum.COMPOSE_REQUEST_MESSAGE,
];

export default (popup, mode, pageNumber) => {
  let visible = false;
  // Don't try to render nonexistent popups, obviously.
  if (popup) {
    // Render a popup only if it's either global or on the current page.
    if (popup.isGlobal || popup.pageIdx === pageNumber) {
      // Regular popups are always rendered, but signature popups have extra conditions.
      if (isRequestSignaturePopup(popup)) {
        // Popups that have been filled in already (no matter by whom) are always shown.
        if (isFilledPopup(popup)) visible = true;
        // Signature popups assigned to the current signer should be visible.
        else if (isPopupAssignedToCurrentSigner(popup)) visible = true;
        // All signature popups should be visible while editing the share.
        else if (EDIT_SHARE_MODES.includes(mode)) visible = true;
        // Otherwise, the popup should not be shown.
      } else {
        // Non-signature popups on the current page are always visible.
        visible = true;
      }
    }
  }
  return visible;
};




// WEBPACK FOOTER //
// ./src-react/Popups/helpers/isVisible.jsx